/*
 * Copyright (c) 2023 Roboto Technologies, Inc.
 */
import { Box, useTheme } from "@mui/material";

import { useAuth } from "@/providers";
// TODO split up organization settings and put into shared components
import { OrganizationSettings } from "@/Settings/OrganizationSettings";

import { AllOrgsViewer } from "./AllOrgsViewer";

export function Orgs() {
  const { currentOrganization, currentUser } = useAuth();
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "45% 45%",
        columnGap: theme.spacing(2.5),
        rowGap: theme.spacing(2.5),
        mt: theme.spacing(2.5),
        overflowX: "auto",
        pb: theme.spacing(0.5),
      }}
    >
      <AllOrgsViewer />
      <OrganizationSettings
        currentOrg={currentOrganization}
        currentUser={currentUser}
      />
    </Box>
  );
}
